<template>
  <div class="client-projects" :class="view_position">
    <div class="client">
      <div class="client-name" @click="back()">
        <div class="mr-4">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="name subheading">{{ client ? client.name : null }}</div>
      </div>
      <div>

        <div class="add-new-project mt-8">
          <div class="btn btn-secondary w-100 mt-8" @click="addNewProject()">
            Add new project
          </div>
        </div>

        <div class="project-type-flag mt-16">ONGOING</div>
        <div class="projects mt-8">
          <div class="project mt-8" v-for="project in _ongoing_projects">
            <div class="project-name" @click="showProject(project)">
              <div class="name subheading" style="padding-right: 1rem;">{{ project.name }}</div>
              <div class="expand">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="divider mt-8"></div>

        <div class="project-type-flag mt-16">COMPLETED</div>
        <div class="projects mt-8">
          <div class="project mt-8" v-for="project in _completed_projects">
            <div class="project-name" @click="showProject(project)">
              <div class="name subheading">{{ project.name }}</div>
              <div class="expand">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="divider mt-8"></div>

        <div class="project-type-flag mt-16">BILLED</div>
        <div class="projects mt-8">
          <div class="project mt-8" v-for="project in _billed_projects">
            <div class="project-name" @click="showProject(project)">
              <div class="name subheading">{{ project.name }}</div>
              <div class="expand">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

export default {
  created() {
    this.$root.$on('ClientProjects::show', (client) => {
      if (client !== false) {
        this.client = client
      }
      this.loadProjects()


      this.move('')
      this.$tpNav.scrollTop()
    })

    this.$root.$on('ClientProjects::reload', () => {
      this.loadProjects()
    })

    this.$root.$on('ClientProjects::setClient', (client) => {
      this.client = client
      this.loadProjects()
    })

    this.$root.$on('ClientProjects::move', (to) => {
      this.move(to)
    })

    this.$root.$on('Projects::created', project => {
      this.projects.push(project)
    })

    this.$root.$on('Projects::deleted', ({project}) => {
      this.$root.$emit('ProjectView::move', 'right-100')
      this.$root.$emit('ClientList::move', 'right-100')
      this.$root.$emit('ClientList::reload')
    })
  },
  data() {
    return {
      client: null,
      projects: null,
      show: false,
      view_position: 'right-100'
    }
  },
  computed: {
    _completed_projects() {
      return _.filter(this.projects, p => !p.active && !p.is_billed)
    },
    _ongoing_projects() {
      return _.filter(this.projects, p => p.active && !p.is_billed)
    },
    _billed_projects() {
      return _.filter(this.projects, p => p.is_billed)
    }
  },
  methods: {
    loadProjects() {
      if (this.client) {
        this.axios.get('n/projects', {params: {client_id: this.client.id}}).then(response => {
          this.projects = response.data.data
        })
      }
    },
    back() {
      this.move('right-100')
      this.$root.$emit('ClientList::show')
      this.$root.$emit('TaskPoolNav::back')
    },
    addNewProject() {
      this.$root.$emit('ProjectModal::add-project', {client: this.client})
    },
    move(to) {
      this.view_position = to
    },
    showProject(project) {
      this.$root.$emit('TaskPoolNav::to-project', project)
      this.move('left-100')
      this.$root.$emit('ProjectView::show', project)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/client-projects.vue